import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { spacing } from '_utils/props';
import { mq, text_s, linkStyle } from '_utils/styles/';
import { Grid } from '_utils/components/Corporate';
import { handleSectionTheme } from '_utils/styles/section';

import { Container as BannerCurveContainer } from '_utils/components/Corporate/BannerCurve/StyledBannerCurve';
import { Container as PageIntroContainer } from '_components/Corporate/PageIntro/StyledPageIntro';

export const ItemWrapper = styled(Grid.Item)`
  & + & {
    margin-top: 24px;

    ${mq('sm')} {
      margin-top: 0;
    }
    @media print {
      margin-top: 0;
    }
  }
`;

export const Container = styled.section<{ $sectionTheme?: string }>`
  ${({ theme }) => spacing({ theme, $py: 7 })};
  ${({ $sectionTheme }) => handleSectionTheme($sectionTheme)}

  ${PageIntroContainer} + &,
  ${BannerCurveContainer} + & {
    padding-top: 0;
  }
`;

export const DetailText = styled.p`
  ${text_s}
`;

export const DetailLink = styled(Link)`
  ${text_s}
  ${({ theme }) => linkStyle(theme.colors.link.secondary)};
`;
